<template>
    <div id="loginPage">
        <div id="loginForm">
            <img src="../../assets/img/logo.svg" alt="">
            <form @submit.prevent="authUser">
                <h2>
                    <img src="../../assets/img/enter.svg" alt="">
                    Authorization
                </h2>
                <input type="text" placeholder="E-mail" v-model="email" :class="{'error':errors.email}" @input="errors.email = '';errors.common = ''">
                <input type="password" placeholder="Password" v-model="password" :class="{'error':errors.password}" @input="errors.password = '';errors.common = ''">
                <span v-if="errors.common" class="error-text">{{errors.common}}</span>
                <input type="submit" value="Login"> 
            </form>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Login',
  data: () => ({
      email:'',
      password:'',
      errors:{
          email:'',
          password:'',
          common:''  
    }
  }),
  methods:{
      authUser(){
          if (this.email == 'admin' && this.password == 'm4k3m0n3y' ||
              this.email == 'gcardoza' && this.password == 'Vall3D3lS@l' ||
              this.email == 'j1' && this.password == 'j2'){
              this.$cookies.set('auth',true);
              this.$router.push('/');
          }
          else{
              this.errors.email = 'Error text';
              this.errors.password = 'Error text';
              this.errors.common = 'User or password is not correct';
          }
      }
  }
};
</script>
<style lang="scss">
#loginPage{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    #loginForm{
        margin-top: 100px;
        text-align: center;
        max-width: 90%;
        @media (max-width: 370px) {
            margin-top: 40px;
        }
        & > img{
            margin-bottom: 40px;
        }
        form{
            background: #FFFFFF;
            border: 1px solid #CDCDEB;
            box-shadow: 0px 10px 20px #E8E8F8;
            border-radius: 12px;
            width: 322px;
            padding: 26px 20px;
            max-width: 100%;
            & > *{
                display: block;
                margin:auto;
                margin-bottom: 20px;
            }
            h2{
                font-size: 20px;
                color: #2E3673;
                margin-bottom: 20px;
                font-weight: 500;
                img{
                    vertical-align: sub;
                    margin-right: 10px;
                }
            }
            input[type=submit]{
                cursor: pointer;
                background: #444BFF;
                border: 1px solid #0D13B3;
                border-radius: 10px;
                width: 136px;
                height: 50px;
                color: white;
                font-family: Poppins;
                font-weight: bold;
                font-size: 14px;
                margin-bottom: 0px;
            }
        }
    }
}
</style>
